const protectedPath = /^\/api\/(challans|bills|payments|site-transfers|inventory|checking|stock-counts|grn|supplier-settlements|salary-v2|loans-v2|govt-receipts|staff-advances|fd-bg|roznamcha|p2)(\/|$)/;

export async function prepareSaveIntent(config) {
  const method = (config.method || 'get').toLowerCase();
  const path = (config.url || '').replace(/^https?:\/\/[^/]+/, '').split('?')[0];
  if (!['post', 'put', 'patch', 'delete'].includes(method) || !protectedPath.test(path)
      || config.data instanceof FormData || config.headers?.['Idempotency-Key']) return null;
  // Per-tab storage distinguishes separately opened entry forms. Store only a
  // fingerprint + random key, never tokens, amounts, documents or bank details.
  const material = `${sessionStorage.getItem('sitepe-tab-id') || ''}:${localStorage.getItem('token')}:${method}:${path}:${JSON.stringify(config.data ?? null)}`;
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(material));
  const fingerprint = [...new Uint8Array(digest)].map(b => b.toString(16).padStart(2, '0')).join('');
  const storageKey = `sitepe-save-${fingerprint}`;
  let key = sessionStorage.getItem(storageKey);
  if (!key) { key = crypto.randomUUID(); sessionStorage.setItem(storageKey, key); }
  config.headers = { ...config.headers, 'Idempotency-Key': key };
  return () => sessionStorage.removeItem(storageKey);
}

export function signalSaveStatus(state, message = '') {
  window.dispatchEvent(new CustomEvent('sitepe-save-status', { detail: { state, message } }));
}